import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { COPY_CODE_MAX_LENGTH, classesValidation } from "../creative-modal/creative-modal-consts";

export const PARENT_VALUE = "PARENT" as const;
export const DEFAULT_TOUCHPOINT_VAL = "1" as const;

const getRequiredFieldValidation = (name: string) => {
  const message = `${name} is required`;
  return z.string({ required_error: message }).nonempty({ message });
};

const getOptionalFieldValidation = () => {
  return z.string().optional();
};

export const CREATE_PARENT_TOUCHPOINT_SCHEMA = zodResolver(
  z.object({
    // Step 1 fields
    campaignId: getRequiredFieldValidation("Campaign name"),
    touchpointName: getRequiredFieldValidation("Email name"),
    campaignObjective: getOptionalFieldValidation(),
    populationType: z.literal(PARENT_VALUE),
    contentType: getRequiredFieldValidation("Content type"),
    copyCode: z.string().max(COPY_CODE_MAX_LENGTH, {
      message: "Please do not exceed character limit.",
    }).optional(),
    fiscalYear: z.number().nullable().optional(),
    emailPrompt: getOptionalFieldValidation(),
    applyClientTheme: z.boolean().optional(),
    insightsActivator: z.boolean().optional(),
    folderId: z.string().optional(),

    // Step 4 - New campaign fields
    newCampaignProgramType: getRequiredFieldValidation("Program type"),
    newCampaignName: getRequiredFieldValidation("Campaign name"),
    newCampaignCdnSubdirectoryName: getOptionalFieldValidation(),
    newCampaignObjective: getRequiredFieldValidation("Campaign objective"),
    newCampaignAudiences: z.array(z.string()).optional(),
    classes: classesValidation,
  }),
);

/** Details → prompt → preview, plus the new-campaign detour (4) reached from details. */
export const PARENT_TOUCHPOINT_STEPS = 4;
